import React from 'react';
import { TableRow } from './components/TableRow';
import { ScrollWrapper, StyledTable, TableWrapper } from './Table.styles';
import TableCell from './components/TableCell';
import TableHeader from './components/TableHeader';
import { TableHead } from './components/TableHead';
import { TableBody } from './components/TableBody';
import { TableCellContainer } from './components/TableCellContainer';
import { TableFooter } from './components/TableFooter/TableFooter';

export interface TableProps {
  renderFooter?: () => React.ReactNode;
  children: React.ReactNode;
}
const Table = ({ children, renderFooter }: TableProps) => {
  return (
    <TableWrapper>
      <ScrollWrapper>
        <StyledTable>{children}</StyledTable>
      </ScrollWrapper>
      {renderFooter && renderFooter()}
    </TableWrapper>
  );
};

export default Object.assign(Table, {
  Cell: TableCell,
  Row: TableRow,
  Head: TableHead,
  Header: TableHeader,
  Body: TableBody,
  CellContainer: TableCellContainer,
  Footer: TableFooter,
});
